const popup = () => {
  const popup = document.querySelectorAll(".popup");
  const popupClick = document.querySelectorAll(".popupBtn");
  const popupClose = document.querySelectorAll(".popup-close");
  const popupOverlay = document.querySelectorAll(".popup__overlay");

  for(let i = 0; i < popupClick.length; i++) {
    popupClick[i].addEventListener('click', function() {
      console.log('clicked');
      popup[i].classList.add('popup--active');
      popupOverlay[i].classList.add('popup__overlay--active');
    });

    popupClose[i].addEventListener('click', function() {
      popup[i].classList.remove('popup--active');
      popupOverlay[i].classList.remove('popup__overlay--active');
    });

    popupOverlay[i].addEventListener("click", function() {
      popup[i].classList.remove('popup--active');
      popupOverlay[i].classList.remove('popup__overlay--active');
    });
  }
}

export default popup